const API_URL = process.env.REACT_APP_API_URL;

export const fetchAllBatchesSimple = async () => {
  const res = await fetch(`${API_URL}/api/batches/all`);
  if (!res.ok) throw new Error("Failed to fetch batches");
  const json = await res.json();
  return json.data || [];
};

export const fetchTrainers = async () => {
  const res = await fetch(`${API_URL}/api/trainers`);
  if (!res.ok) throw new Error("Failed to fetch trainers");
  return await res.json(); // plain array
};

export const fetchTrainerById = async (id) => {
  const res = await fetch(`${API_URL}/api/trainers/${id}`);
  if (!res.ok) throw new Error("Failed to fetch trainer");
  const json = await res.json();
  return json.data;
};

export const fetchTrainerActivity = async (id, page = 1, limit = 20) => {
  const res = await fetch(`${API_URL}/api/trainers/${id}/activity?page=${page}&limit=${limit}`);
  if (!res.ok) throw new Error("Failed to fetch activity logs");
  const json = await res.json();
  return json.data; // { logs, total, page, limit }
};

export const createTrainer = async (payload) => {
  const res = await fetch(`${API_URL}/api/trainers`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || "Failed to create trainer");
  }
  return await res.json();
};

export const updateTrainer = async (id, payload) => {
  const res = await fetch(`${API_URL}/api/trainers/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || "Failed to update trainer");
  }
  return await res.json();
};

export const deleteTrainer = async (id) => {
  const res = await fetch(`${API_URL}/api/trainers/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Failed to delete trainer");
  return await res.json();
};
